import React from "react";
import DeviceEmulator from "react-device-emulator";
import "react-device-emulator/lib/styles/style.css";
import BottomBar from "../BottomBar";
import ReactCardFlip from "react-card-flip";
import StoryContentView from "./ContentView/StoryContentView";
import McqContentView from "./ContentView/McqContentView";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "../../Utils/ResponsiveScreen";
import FlipToStoryView from "./ContentView/FlipToStoryView";
import OnlyCoverView from "./ContentView/OnlyCoverView";
import InAppBrowserView from "./ContentView/InAppBrowserView";
import SlideShowView from "./ContentView/SlideShowView";

import PollContentView from "./ContentView/PollContentView";
import RenderContentData from "./RenderContentData";

class ApproveCreatedContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dispShowMore: false,
      explanationModal: false,
      isFlipped: false,
    };
  }
  handleClick = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  };

  coverStoryContentView = () => {
    const { data, contentSelectedLangVal } = this.props;
    const {
      coverStoryType,
      flipToStoryDetails,
      onlyCoverDetails,
      inAppBrowserDetails,
    } = data.contentMetaInfo.coverStoryDetails;
    let title = "";
    let cardDescription = "";
    switch (coverStoryType) {
      case "FlipToStory":
        title = flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`];
        cardDescription =
          flipToStoryDetails[
            `coverStoryCardDescription_${contentSelectedLangVal}`
          ];

      case "OnlyCover":
        title = onlyCoverDetails[`coverStoryTitle_${contentSelectedLangVal}`];
        cardDescription =
          onlyCoverDetails[
            `coverStoryCardDescription_${contentSelectedLangVal}`
          ];

      case "InAppBrowser":
        title =
          inAppBrowserDetails[`coverStoryTitle_${contentSelectedLangVal}`];
        cardDescription = "";

      default:
        title = "";
        cardDescription = "";
    }
    const contentID = data.contentID
      ? data.contentID
      : data.PK.split("cont#")[1];

    return (
      <RenderContentData
        duplicateContent={this.props.duplicateContent}
        loggedInUserId={this.props.loggedInUserId}
        contentID={contentID}
        data={data}
        displayToast={this.props.displayToast}
        contentLanguage={contentSelectedLangVal}
        title={flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
        cardDescription={
          flipToStoryDetails[
            `coverStoryCardDescription_${contentSelectedLangVal}`
          ]
        }
        selectedPnPriority={data.selectedPnPriority}
        pnTitle={data.pnTitle}
        pnDescription={data.pnDescription}
        bigTextTitle={data.bigTextTitle}
        contentLanguages={data.contentLanguages}
        contentMainCategory={data.contentMainCategory}
        contentType={data.contentType}
        pnDescription_Te={data[`pnDescription_${contentSelectedLangVal}`]}
        pnPriority={data.pnPriority}
        pnTitle_Te={data[`pnTitle_${contentSelectedLangVal}`]}
        sendPNWithImage={data.sendPNWithImage}
        contentCategory1={data.contentCategory1}
        contentCategory2={data.contentCategory2}
        contentCategory3={data.contentCategory3}
        sendPushNotification={data.sendPNWithImage}
        stickyPost={data.stickyPost}
        syncToYousaytv={data.syncToYousaytv}
        targetAreaV2={data.targetAreaV2}
      />
    );
  };

  renderContent = (contentType) => {
    const { data, contentSelectedLangVal } = this.props;
    const contentID = data.contentID
      ? data.contentID
      : data.PK.split("cont#")[1];
    // const contentType = 'Story'
    let title = "";
    let cardDescription = "";
    switch (contentType) {
      case "Story":
        title =
          data.contentMetaInfo.storyDetails[
            `storyTitle_${contentSelectedLangVal}`
          ];
        cardDescription =
          data.contentMetaInfo.storyDetails[
            `storyCardDescription_${contentSelectedLangVal}`
          ];
        return (
          <RenderContentData
            duplicateContent={this.props.duplicateContent}
            loggedInUserId={this.props.loggedInUserId}
            contentID={contentID}
            data={data}
            displayToast={this.props.displayToast}
            contentLanguage={contentSelectedLangVal}
            title={title}
            cardDescription={cardDescription}
            selectedPnPriority={data.selectedPnPriority}
            pnTitle={data.pnTitle}
            pnDescription={data.pnDescription}
            bigTextTitle={data.bigTextTitle}
            contentLanguages={data.contentLanguages}
            contentMainCategory={data.contentMainCategory}
            contentType={data.contentType}
            pnDescription_Te={data.pnDescription_Te}
            pnPriority={data.pnPriority}
            pnTitle_Te={data.pnTitle_Te}
            sendPNWithImage={data.sendPNWithImage}
            contentCategory1={data.contentCategory1}
            contentCategory2={data.contentCategory2}
            contentCategory3={data.contentCategory3}
            stickyPost={data.stickyPost}
            syncToYousaytv={data.syncToYousaytv}
            targetAreaV2={data.targetAreaV2}
          />
        );
      // return (

      // <StoryContentView
      // 	preview={true}
      // 	content={data}
      // 	contentType={contentType}
      // 	title={data.contentMetaInfo.storyDetails[`storyTitle_${contentSelectedLangVal}`]}
      // 	cardDescription={
      // 		data.contentMetaInfo.storyDetails[`storyCardDescription_${contentSelectedLangVal}`]
      // 	}
      // 	cardImages={
      // 		data.contentMetaInfo.storyDetails.storyCardOriginalImages
      // 			? data.contentMetaInfo.storyDetails.storyCardOriginalImages
      // 			: data.contentMetaInfo.storyDetails.storyCardImages
      // 	}
      // 	contentLinkDetails={data.contentMetaInfo.storyDetails.contentLinkDetails}
      // 	contentNewLinkDetails={data.contentMetaInfo.storyDetails.contentNewLinkDetails}
      // 	coverStoryVideoURL={data.contentMetaInfo.storyDetails.coverStoryVideoURL}
      // />
      // )
      case "CoverStory":
        return this.coverStoryContentView();
      case "Mcq":
        title =
          data.contentMetaInfo.mcqDetails[`mcqTitle_${contentSelectedLangVal}`];
        cardDescription =
          data.contentMetaInfo.mcqDetails[
            `explanationCardTitle_${contentSelectedLangVal}`
          ];

        return (
          <RenderContentData
            duplicateContent={this.props.duplicateContent}
            loggedInUserId={this.props.loggedInUserId}
            contentID={contentID}
            data={data}
            displayToast={this.props.displayToast}
            contentLanguage={contentSelectedLangVal}
            title={title}
            cardDescription={cardDescription}
            selectedPnPriority={data.selectedPnPriority}
            pnTitle={data.pnTitle}
            pnDescription={data.pnDescription}
            bigTextTitle={data.bigTextTitle}
            contentLanguages={data.contentLanguages}
            contentMainCategory={data.contentMainCategory}
            contentType={data.contentType}
            pnDescription_Te={data.pnDescription_Te}
            pnPriority={data.pnPriority}
            pnTitle_Te={data.pnTitle_Te}
            sendPNWithImage={data.sendPNWithImage}
            contentCategory1={data.contentCategory1}
            contentCategory2={data.contentCategory2}
            contentCategory3={data.contentCategory3}
            sendPushNotification={data.sendPNWithImage}
            stickyPost={data.stickyPost}
            syncToYousaytv={data.syncToYousaytv}
            targetAreaV2={data.targetAreaV2}
          />
        );
      // return (
      // 	<McqContentView
      // 		preview={true}
      // 		content={data}
      // 		mcqTitle={data.contentMetaInfo.mcqDetails[`mcqTitle_${contentSelectedLangVal}`]}
      // 		explanationCardTitle={
      // 			data.contentMetaInfo.mcqDetails[`explanationCardTitle_${contentSelectedLangVal}`]
      // 		}
      // 		answerExplanation={
      // 			data.contentMetaInfo.mcqDetails[`answerExplanation_${contentSelectedLangVal}`]
      // 		}
      // 		contentVisibleLang={contentSelectedLangVal}
      // 		contentNewLinkDetails={data.contentMetaInfo.mcqDetails.contentNewLinkDetails}
      // 	/>
      // )

      case "Poll":
        title =
          data.contentMetaInfo.pollDetails[
            `pollTitle_${contentSelectedLangVal}`
          ];
        cardDescription =
          data.contentMetaInfo.pollDetails[
            `pollDescription_${contentSelectedLangVal}`
          ];

        return (
          <RenderContentData
            duplicateContent={this.props.duplicateContent}
            loggedInUserId={this.props.loggedInUserId}
            contentID={contentID}
            data={data}
            displayToast={this.props.displayToast}
            contentLanguage={contentSelectedLangVal}
            title={title}
            cardDescription={cardDescription}
            selectedPnPriority={data.selectedPnPriority}
            pnTitle={data.pnTitle}
            pnDescription={data.pnDescription}
            bigTextTitle={data.bigTextTitle}
            contentLanguages={data.contentLanguages}
            contentMainCategory={data.contentMainCategory}
            contentType={data.contentType}
            pnDescription_Te={data.pnDescription_Te}
            pnPriority={data.pnPriority}
            pnTitle_Te={data.pnTitle_Te}
            sendPNWithImage={data.sendPNWithImage}
            contentCategory1={data.contentCategory1}
            contentCategory2={data.contentCategory2}
            contentCategory3={data.contentCategory3}
            sendPushNotification={data.sendPNWithImage}
            stickyPost={data.stickyPost}
            syncToYousaytv={data.syncToYousaytv}
            targetAreaV2={data.targetAreaV2}
          />
        );
      // return (

      // 	<PollContentView
      // 		preview={true}
      // 		content={data}
      // 		pollTitle={data.contentMetaInfo.pollDetails[`pollTitle_${contentSelectedLangVal}`]}
      // 		pollDescription={
      // 			data.contentMetaInfo.pollDetails[`pollDescription_${contentSelectedLangVal}`]
      // 		}
      // 		contentVisibleLang={contentSelectedLangVal}
      // 		contentNewLinkDetails={data.contentMetaInfo.pollDetails.contentNewLinkDetails}
      // 	/>
      // )
      case "SlideShow":
        // title = ''
        // cardDescription = ''
        return (
          <SlideShowView
            isPausedVideo={this.state.isPausedVideo}
            content={data}
            preview={true}
            contentVisibleLang={contentSelectedLangVal}
          />
        );
      case "liveNews":
        title =
          data.contentMetaInfo.liveNewsSectionDetails[0][
            `liveNewsTitle_${contentSelectedLangVal}`
          ];
        cardDescription =
          data.contentMetaInfo.liveNewsSectionDetails[0][
            `liveNewsDescription_${contentSelectedLangVal}`
          ];
        return (
          <RenderContentData
            duplicateContent={this.props.duplicateContent}
            loggedInUserId={this.props.loggedInUserId}
            contentID={contentID}
            data={data}
            displayToast={this.props.displayToast}
            contentLanguage={contentSelectedLangVal}
            title={title}
            cardDescription={cardDescription}
            selectedPnPriority={data.selectedPnPriority}
            pnTitle={data.pnTitle}
            pnDescription={data.pnDescription}
            bigTextTitle={data.bigTextTitle}
            contentLanguages={data.contentLanguages}
            contentMainCategory={data.contentMainCategory}
            contentType={data.contentType}
            pnDescription_Te={data.pnDescription_Te}
            pnPriority={data.pnPriority}
            pnTitle_Te={data.pnTitle_Te}
            sendPNWithImage={data.sendPNWithImage}
            contentCategory1={data.contentCategory1}
            contentCategory2={data.contentCategory2}
            contentCategory3={data.contentCategory3}
            stickyPost={data.stickyPost}
            syncToYousaytv={data.syncToYousaytv}
            targetAreaV2={data.targetAreaV2}
          />
        );
      default:
        return (
          <RenderContentData
            duplicateContent={this.props.duplicateContent}
            category={data.selectedCategory}
            loggedInUserId={this.props.loggedInUserId}
            contentID={contentID}
            data={data}
            displayToast={this.props.displayToast}
            contentLanguage={contentSelectedLangVal}
            title={""}
            cardDescription={""}
            selectedPnPriority={data.selectedPnPriority}
            pnTitle={data.pnTitle}
            pnDescription={data.pnDescription}
            bigTextTitle={data.bigTextTitle}
            contentLanguages={data.contentLanguages}
            contentMainCategory={data.contentMainCategory}
            contentType={data.contentType}
            pnDescription_Te={data.pnDescription_Te}
            pnPriority={data.pnPriority}
            pnTitle_Te={data.pnTitle_Te}
            sendPNWithImage={data.sendPNWithImage}
            contentCategory1={data.contentCategory1}
            contentCategory2={data.contentCategory2}
            contentCategory3={data.contentCategory3}
            sendPushNotification={data.sendPNWithImage}
            stickyPost={data.stickyPost}
            syncToYousaytv={data.syncToYousaytv}
            targetAreaV2={data.targetAreaV2}
          />
        );
    }
  };

  render() {
    const { data, type } = this.props;
    console.log(data.sendPNWithImage, "sendPushNotification");
    console.log(data, "dataaa");
    return <div>{this.renderContent(data.contentType)}</div>;
  }
}

export default ApproveCreatedContent;
